<template>
  <div class="help-resources">
    <HelpResources :resources="resources">
      <template #title>{{ t("helpResources.needHelp") }}</template>
    </HelpResources>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue"
import { useI18n } from "vue-i18n"
import HelpResources from "@/components/HelpResources/HelpResources.vue"
import getEnv from "@/common/util/env"
import { includes } from "lodash"
import { useLinks } from "@/composables/useLinks"

const { t } = useI18n()
const { footerLinks } = useLinks()
const SWAGGER_URL = includes(getEnv("VITE_APP_FEATURES"), "api-access")
  ? getEnv("VITE_SWAGGER_URL")
  : getEnv("VITE_APP_SUPPORT_EMAIL")

const resources = ref([
  {
    title: t("helpResources.developerDoc"),
    description: t("helpResources.developerDocDesc"),
    buttonText: t("helpResources.browse"),
    tooltip: t("helpResources.contactUs"),
    tooltipDisabled: includes(getEnv("VITE_APP_FEATURES"), "api-access"),
    cardIcon: '<scale-icon name="support-chat" />',
    buttonLink: SWAGGER_URL,
    isButtonDisabled: !includes(getEnv("VITE_APP_FEATURES"), "api-access")
  },
  {
    title: t("helpResources.tutorials"),
    description: t("helpResources.exampleDescription"),
    buttonText: t("helpResources.browse"),
    tooltip: "",
    tooltipDisabled: true,
    cardIcon: '<scale-icon name="video" />',
    buttonLink: footerLinks().tutorials,
    isButtonDisabled: false
  },
  {
    title: t("helpResources.glossary"),
    description: t("helpResources.glossaryDescription"),
    buttonText: t("helpResources.browse"),
    tooltip: "",
    tooltipDisabled: true,
    cardIcon: '<scale-icon name="news" />',
    buttonLink: footerLinks().glossary,
    isButtonDisabled: false
  }
])
</script>
<style lang="scss" scoped>
.help-resources {
  border-radius: var(--scl-spacing-12);
  padding: var(--scl-spacing-24);
  background: var(--telekom-color-background-surface-subtle);
}
</style>
